import styled, { css } from 'styled-components';

import Footer from './Footer';
import ListItem from './ListItem';
import Question from './Question';
import Section from './Section';
import Wrapper from './Wrapper';

const limitHeight = css`
  height: calc(100vh - 80px);
  max-height: calc(100vh - 80px);
  overflow: auto;
`;

const StudentQuestion = styled('div')<{ noLimitHeight?: boolean }>`
  display: grid;
  ${(props) => !props.noLimitHeight && limitHeight};
  grid-template-columns: 1fr;
  grid-template-areas:
    'title'
    'content'
    'contact'
    'footer';
  grid-template-rows: auto 1fr auto auto;
  //grid-row-gap: 32px; TODO check if does not break stying of something
  margin-bottom: 100px;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}) {
    margin-bottom: 0;
  }
`;

type PageProps = typeof StudentQuestion & {
  Section: typeof Section;
  Wrapper: typeof Wrapper;
  Footer: typeof Footer;
  Question: typeof Question;
  ListItem: typeof ListItem;
};

/**
 * @deprecated We should add <Spacer />. Use <div /> instead.
 */
const StudentQuestionBlock = StudentQuestion as PageProps;

StudentQuestionBlock.Section = Section;
StudentQuestionBlock.Wrapper = Wrapper;
StudentQuestionBlock.Footer = Footer;
StudentQuestionBlock.Question = Question;
StudentQuestionBlock.ListItem = ListItem;

export default StudentQuestionBlock;
